import { client } from '../../helpers/content';
import initialState from './initial_state.json';

const SET_ENTRY = 'SET_CONTENTFUL_ENTRY';
const CONTENTFUL_GET_SUCCESS = 'CONTENTFUL_GET_SUCCESS';
const CONTENTFUL_GET = 'CONTENTFUL_GET';
export const actions = {
  setEntry: payload => ({
    type: SET_ENTRY,
    payload,
  }),
  contentfulGetSuccess: payload => ({
    type: CONTENTFUL_GET_SUCCESS,
    payload,
  }),
  contentfulGet: entryId => ({
    type: CONTENTFUL_GET,
    payload: {
      entryId,
    },
  }),
};

export function reducer(state = initialState, action) {
  if (action.type === SET_ENTRY || action.type === CONTENTFUL_GET_SUCCESS) {
    return {
      ...state,
      [action.payload.entryId]: action.payload.entry,
    };
  }

  return state;
}

export const selectors = {
  getEntry: (state = {}, entryId) =>
    state.contentful && state.contentful[entryId],
};

export function epic() {
  return (action, { dispatch }) => {
    if (action.type === CONTENTFUL_GET) {
      return (
        client &&
        client.getEntry(action.payload.entryId).then(entry => {
          dispatch(
            actions.contentfulGetSuccess({
              entry,
              entryId: action.payload.entryId,
            })
          );
        })
      );
    }
  };
}
